import { createRouter, createWebHashHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import StudentSummary from "../views/StudentSummary.vue";
import TeacherTemp from "../views/TeacherTemp.vue";
import StudentTempManage from "../views/StudentTempManage.vue";
import RTL from "../views/Rtl.vue";
import Notifications from "../views/Notifications.vue";
import Profile from "../views/Profile.vue";
import SignIn from "../views/SignIn.vue";
import SignUp from "../views/SignUp.vue";

// 신규
import MemberList from "../views/MemberList.vue";
//import Login from "../views/Login.vue";
import MemberBook from "../views/MemberBook.vue";
import AttendList from "../views/AttendList.vue";
import TeacherList from "../views/TeacherList.vue";
import FileList from "../views/FileList.vue";
import ClassManage from "../views/ClassManage.vue";
import store from '@/store'; // Vuex 스토어 임포트
import AttendGrid from "../views/AttendGrid.vue";
import AttendWeekly from "../views/AttendWeekly.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/sign-in",
  },
  {
    path: "/studentsummary",
    name: "StudentSummary",
    component: StudentSummary,
  },
  {
    path: "/teachertemp",
    name: "TeacherTemp",
    component: TeacherTemp,
  },
  {
    path: "/studenttemp",
    name: "StudentTempManage",
    component: StudentTempManage,
  },
  {
    path: "/memberlist",
    name: "MemberList",
    component: MemberList,
    meta: { requiresAuth: false, role: 4 }, //// role 권한이 4 이하만 접근 가능
  },
  // {
  //   path: "/login",
  //   name: "Login",
  //   component: Login,
  // },
  {
    path: "/memberbook",
    name: "Memberbook",
    component: MemberBook,
    meta: { requiresAuth: false, role: 4 },
},
{
    path: "/attendlist",
    name: "AttendList",
    component: AttendList,
    meta: { requiresAuth: false, role: 4 },
},
{
  path: "/teacherlist",
  name: "TeacherList",
  component: TeacherList,
  meta: { requiresAuth: false, role: 4 }, //// role 권한이 4 이하만 접근 가능
},
{
  path: "/classmanage",
  name: "ClassManage",
  component: ClassManage,
  meta: { requiresAuth: false, role: 4 },
},
{
  path: "/filelist",
  name: "FileList",
  component: FileList,
},
{
  path: "/attendgrid",
  name: "AttendGrid",
  component: AttendGrid,
},
{
  path: "/attendweekly",
  name: "AttendWeekly",
  component: AttendWeekly,
},
  ///////////////////////////////////// 아래는 아님 ////////////////////////////////////
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/sign-in",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: SignUp,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const currentUser = store.state.isAuthenticated;
 // const userRole = store.state.userData.role; // 사용자의 역할을 저장하는 상태 변수 가정

  if (requiresAuth && !currentUser) {
    // 사용자가 인증되지 않았으면 로그인 페이지로 리다이렉트
    next({ name: 'SignIn' });
  //} else if (requiresAuth && currentUser && to.meta.role && userRole > to.meta.role) {
  } else if (requiresAuth && currentUser ) {
    // 권한이 필요하고, 사용자의 권한이 부족한 경우 접근 거부
    alert("You don't have permission to access this page.");
    next(from.fullPath); // 이전 페이지로 돌아가기
  } else {
    next(); // 모든 검사를 통과했다면 다음 라우트로 이동
  }
});

export default router;
